import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FileUploadType } from 'src/app/core/enums';
import { Utils } from 'src/app/core/utils';
import { findConfigFile } from 'typescript';


@Component({
  selector: 'app-browser-state',
  templateUrl: './browser-state.component.html',
  styleUrls: ['./browser-state.component.scss']
})
export class BrowserStateComponent implements OnInit {


  @ViewChild('file') file: ElementRef<HTMLElement>;

  cameraPermission = '';


  windowInnerWidth = 0;
  windowInnerHeight = 0;
  windowOuterWidth = 0;
  windowOuterHeight = 0;
  fileUploadType: FileUploadType = FileUploadType.Undefined;

  _navigator = {
    appName: '',
    vendor: '',
    userAgent: '',
    connection: {
      saveData: ''
    },
    cookieEnabled: '',
    language: '',
    languages: '',
    platform: '',
    product: '',
    productSub: '',
    oscpu: '',
  };


  constructor() { }

  ngOnInit(): void {
    this.checkCemaraPermission();


    for (var i in navigator)
      this._navigator[i] = navigator[i];

    this.windowInnerHeight = window.innerHeight;
    this.windowInnerWidth = window.innerWidth;
    this.windowOuterHeight = window.outerHeight;
    this.windowOuterWidth = window.outerWidth;
  }



  checkCemaraPermission() {

    var browser = <any>navigator;
    browser.permissions.query({ name: 'camera' }).then((result) => {
      this.cameraPermission = '{ name: ' + result.name + ', state: ' + result.state + '}';
    })


    // navigator.mediaDevices.getUserMedia({ audio: true, video: true })
    //   .then(stream => console.log(stream))
    //   .catch(err => console.error(err));
  }

  onCaptureImageMouseUp(event: any) {
    try {
      this.fileUploadType = FileUploadType.Image;
      let el: HTMLElement = this.file.nativeElement;
      Utils.dispatchEvent(el, 'mouseup');
    } catch (error) {
      alert(error);
    }

  }

  onCaptureImageMouseDown(event: any) {
    try {
      this.fileUploadType = FileUploadType.Image;
      let el: HTMLElement = this.file.nativeElement;
      Utils.dispatchEvent(el, 'mousedown');
    } catch (error) {
      alert(error);
    }
  }

  onCaptureImageTouchStart(event: any) {
    try {
      this.fileUploadType = FileUploadType.Image;
      let el: HTMLElement = this.file.nativeElement;
      Utils.dispatchEvent(el, 'touchstart');
    } catch (error) {
      alert(error);
    }
  }

  onFileClick(event) {
    alert('onFileClick 200');
    try {
      // trigger file upload without checking permission - if granted the camera will open
      this.fileUploadType = FileUploadType.Image;
      let el: HTMLElement = this.file.nativeElement;
      Utils.dispatchEvent(el, 'click');
    } catch(error) {
      alert(error);
    }
  }

  onCaptureImageClicked(event: any) {
   
    try {
      alert('onCaptureImageClicked step 100');
      // check permission for camera
      // permissions.query  can only be found in Chrome 44 and later and Firefox 43 and later.
      if (Utils.isMobile()) {
        alert('onCaptureImageClicked step 101');
        var browser = <any>navigator;
        browser.permissions.query({ name: 'camera' }).then(result => {
          alert('onCaptureImageClicked step 102');
          console.log(result);
          if (result.state === 'denied') { //"denied" | "granted" | "prompt";           
            alert('access is denied');
          }
          else {
            alert('onCaptureImageClicked step 103');
            // trigger file upload
            this.fileUploadType = FileUploadType.Image;
            let el: HTMLElement = this.file.nativeElement;
            Utils.dispatchEvent(el, 'click');
          }
        })
      }
      else {
        alert('onCaptureImageClicked step 104');

        // trigger file upload without checking permission - if granted the camera will open
        this.fileUploadType = FileUploadType.Image;
        let el: HTMLElement = this.file.nativeElement;
        Utils.dispatchEvent(el, 'click');
      }

    }
    catch (err) {

      try {
        alert('onCaptureImageClicked step 105');
        // trigger file upload without checking permission - if granted the camera will open
        this.fileUploadType = FileUploadType.Image;
        let el: HTMLElement = this.file.nativeElement;
        Utils.dispatchEvent(el, 'click');
        

      }
      catch (err2) {
        alert('onCaptureImageClicked step 106');
      }
    }
    finally{
      return true;
    }

  }

  onFileChange(event: any) {
    alert('file change');
  }

}
